"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var rbac_1 = require("./rbac");
var generateAppConfig = function (user) {
    if (utils_1.getIsRbacUser(user)) {
        return rbac_1["default"](user);
    }
    var config = {};
    var scopes = user.scopes, gates = user.gates, roles = user.roles;
    var isOrgAdmin = utils_1.getIsOrgAdmin(scopes);
    var isReportingUser = utils_1.getIsReportingUser(roles);
    // check access to insights application
    config = ramda_1.set(ramda_1.lensProp('hasInsights'), !!gates.has_insights && (isOrgAdmin || isReportingUser), config);
    // check access to saved searches
    config = ramda_1.set(ramda_1.lensProp('hasSavedSearches'), !!gates.enterprise_04_2018, config);
    // allow for 1 year on the datepicker
    config = ramda_1.set(ramda_1.lensProp('hasYearHistory'), !!gates.premium_enterprise || !!gates.enterprise_04_2018, config);
    // check access to beta currently used for automated tasks
    config = ramda_1.set(ramda_1.lensProp('insightsBeta'), !!gates.insights_beta, config);
    // check access to beta features
    config = ramda_1.set(ramda_1.lensProp('insightsFeatureBeta'), !!gates.insights_feature_beta, config);
    // check access to cluster insight features
    config = ramda_1.set(ramda_1.lensProp('hasClusterInsights'), !!gates.has_cluster_insights, config);
    // check access to convo alerts
    config = ramda_1.set(ramda_1.lensProp('hasConvoAlerts'), !!gates.has_convo_alerts, config);
    return config;
};
exports["default"] = generateAppConfig;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@driftt/app-config/dist/appConfigs/insightsWeb/index.js
// module id = zcC+
// module chunks = 88